import { Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

export const IconWalletOutline = (props: IconProps) => {
  const { size = 16, color, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      color={color ?? 'black'}
      {...otherProps}
    >
      <Path
        fill="currentColor"
        d="M6 19.5C5.03467 19.5 4.21 19.158 3.526 18.474C2.842 17.79 2.5 16.9653 2.5 16V8C2.5 7.03467 2.842 6.21 3.526 5.526C4.21 4.842 5.03467 4.5 6 4.5H18C18.9653 4.5 19.79 4.842 20.474 5.526C21.158 6.21 21.5 7.03467 21.5 8V16C21.5 16.9653 21.158 17.79 20.474 18.474C19.79 19.158 18.9653 19.5 18 19.5H6ZM6 8.25H18C18.3795 8.25 18.7375 8.3045 19.074 8.4135C19.4105 8.5225 19.7192 8.68792 20 8.90975V8C20 7.45 19.8042 6.97917 19.4125 6.5875C19.0208 6.19583 18.55 6 18 6H6C5.45 6 4.97917 6.19583 4.5875 6.5875C4.19583 6.97917 4 7.45 4 8V8.90975C4.28083 8.68792 4.5895 8.5225 4.926 8.4135C5.2625 8.3045 5.6205 8.25 6 8.25ZM4.09225 11.2405L15.323 13.9692C15.4602 14.0026 15.599 14.0042 15.7395 13.974C15.8798 13.9438 16.0071 13.882 16.1212 13.7885L19.7213 10.7635C19.5571 10.4622 19.3221 10.2179 19.0163 10.0307C18.7106 9.84358 18.3718 9.75 18 9.75H6C5.52817 9.75 5.11858 9.88817 4.77125 10.1645C4.42375 10.4407 4.19742 10.7993 4.09225 11.2405Z"
      />
    </Svg>
  );
};
